import axiosInstance from "./axiosInstance";

const createBooking = (bookingData) =>
  axiosInstance.post(`/bookings`, { booking: bookingData });

const getBookings = (page) =>
  axiosInstance.get(`/bookings`, {
    params: page,
  });

const getBookingsPerUser = (page) =>
    axiosInstance.get(`/bookings/index_per_user`, {
      params: page,
    });

//nezgrapan naziv, ali se misli na sve bukinge od jednog foreign partnera
const getAllForeignPartnersBookings = (page) =>
    axiosInstance.get(`/bookings/get_all_foreign_partners_bookings`, {
        params: page,
    });

const getBooking = (bookingId) => axiosInstance.get(`/bookings/${bookingId}`);

const getPendingBookings = (page) =>
  axiosInstance.get(`/bookings/pending`, {
    params: page,
  });

const changeBookingStatus = (bookingId, { currentStatus }) =>
  axiosInstance.patch(`/bookings/${bookingId}/`, {
    booking: { currentStatus },
  });

const updateBookingContact = (bookingUuid, contact) =>
  axiosInstance.patch(`/bookings/${bookingUuid}/`, {
    booking: {
      clientFirstName: contact.firstName,
      clientLastName: contact.lastName,
      clientEmail: contact.email,
      clientPhone: contact.telephoneNumber,
      clientNameOnPassport: contact.nameOnPassport,
      clientPassportExpiresOn: contact.passportExpiresAt,
    },
  });

const submitPhotosToBooking = (bookingId, images, reservationPassport) => {
  const formData = new FormData();
  images.forEach((image, index) => {
    formData.append(`${index}`, image);
  });
  formData.append("reservation_passport", JSON.stringify(reservationPassport));

  return axiosInstance.post(
    `/bookings/${bookingId}/google_drive_images`,
    formData,
    {
      headers: {
        "Content-Type": "multipart/form-data",
        "Key-Inflection": "camel",
      },
    }
  );
};

const authorizeOrder = (bookingId, orderId) => {
  return axiosInstance.post(`/bookings/${bookingId}/paypal/authorize`, {
    orderId: orderId,
  });
};

const getBookedDatesByBookableId = (bookableId, bookableType) =>
    axiosInstance.get(`/bookings/booking_details/`, {
      params : {
        bookable_id: bookableId,
        bookable_type: bookableType
      }});

const patchPromoOrder = (bookingId, promoCodeId, code) => axiosInstance.patch(`/bookings/${bookingId}/promo_order`, {
  params : {
    promoCodeId: promoCodeId,
    code: code,
  }
})

const deleteBookingImages = (bookingId, imageIds) =>
  axiosInstance.delete(`/bookings/${bookingId}/google_drive_images/bulk_destroy`, {
    data: { ids: imageIds },
  });

const deleteDraftBooking = (bookingUuid) =>
  axiosInstance.delete(`/bookings/${bookingUuid}`);

export {
  createBooking,
  getBookings,
  getBooking,
  getPendingBookings,
  submitPhotosToBooking,
  changeBookingStatus,
  authorizeOrder,
  getBookedDatesByBookableId,
  patchPromoOrder,
  getBookingsPerUser,
  getAllForeignPartnersBookings,
  deleteDraftBooking,
  deleteBookingImages,
  updateBookingContact,
};
